import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-calculator-icon lucide-calculator",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 20,
			x: 4,
			y: 2,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			x2: 16,
			y1: 6,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			x2: 16,
			y1: 14,
			y2: 18
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 14h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 14h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 18h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 18h.01" })
	]
});
export default SvgCalculator;
